<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.89583 0H1.97917C0.890625 0 0.00989606 0.9 0.00989606 2L0 18C0 19.1 0.880729 20 1.96927 20H13.8542C14.9427 20 15.8333 19.1 15.8333 18V6L9.89583 0ZM11.875 16H3.95833V14H11.875V16ZM11.875 12H3.95833V10H11.875V12ZM8.90625 7V1.5L14.349 7H8.90625Z" fill="#009DD6"/>
</svg>
